import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg className={className} width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.3751 6C14.3751 7.16032 13.9141 8.27312 13.0936 9.09359C12.2732 9.91406 11.1604 10.375 10.0001 10.375C8.83973 10.375 7.72693 9.91406 6.90646 9.09359C6.08599 8.27312 5.62505 7.16032 5.62505 6C5.62505 4.83968 6.08599 3.72688 6.90646 2.90641C7.72693 2.08594 8.83973 1.625 10.0001 1.625C11.1604 1.625 12.2732 2.08594 13.0936 2.90641C13.9141 3.72688 14.3751 4.83968 14.3751 6V6ZM1.25122 22.471C1.28871 20.1754 2.22695 17.9865 3.86359 16.3764C5.50024 14.7663 7.70416 13.8639 10.0001 13.8639C12.296 13.8639 14.4999 14.7663 16.1365 16.3764C17.7732 17.9865 18.7114 20.1754 18.7489 22.471C16.0042 23.7296 13.0196 24.3791 10.0001 24.375C6.87805 24.375 3.91472 23.6937 1.25122 22.471Z"
      stroke="#494949"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Icon;
